var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"src":_vm.path,"width":_vm.width,"content":_vm.country ? _vm.country.name_fr : _vm.code}})
}
var staticRenderFns = []

export { render, staticRenderFns }